import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { Acoes } from '../../../../../core/acoes';
import { DataUtilService } from '../../../../../services/commons/data-util.service';

@Component({
    selector: 'listar-acoes-turma',
    templateUrl: './listar-acoes-oficina-turma.component.html',
    styleUrls: ['./listar-acoes-oficina-turma.component.css']
})
export class ListarAcoesOficinaTurmaComponent implements OnInit {

    @Output() onAtualizarAcao = new EventEmitter();
    @Output() onAdicionar = new EventEmitter();

    @Input() acoesAtividade: Acoes[];

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    mostrarTabela = false;
    msg: string;

    displayedColumns: string[] = ['dataInicio', 'dataFim', 'descricao', 'acoes'];
    dataSource: MatTableDataSource<Acoes> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    filteredRequests: MatTableDataSource<Acoes> = new MatTableDataSource();
    descricaoFiltered: string;
    dataFiltered: string;

    constructor(private activatedRoute: ActivatedRoute,
                private dataUtilService: DataUtilService) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

        this.dataSource.paginator = this.paginator;
        this.carregarLista();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["acoesAtividade"] && !_.isEmpty(changes["acoesAtividade"].currentValue)) {
            this.carregarLista();
        }
    }

    getStatusLabel(statusAnalise: string): string {
        if (!statusAnalise) return 'Aguardando';
        return statusAnalise === 'A'
            ? 'Aprovado'
            : statusAnalise === 'R'
            ? 'Reprovado'
            : 'Em Análise';
    }   

    carregarLista() {
        if (_.isEmpty(this.acoesAtividade)) {
            this.mostrarTabela = false;
            this.msg = 'Nenhuma ação cadastrada.';
        } else {
            this.dataSource.data = this.acoesAtividade;
            this.mostrarTabela = true;
        }

        this.filteredRequests = this.dataSource;
    }

    deletar(acaoAtividade: any): void {
        const index = this.acoesAtividade.indexOf(this.acoesAtividade.find(col => col === acaoAtividade));
        if (index >= 0) {
            this.acoesAtividade.splice(index, 1);
            this.carregarLista();
        }
    }

    atualizar(acaoAtividade: Acoes) {
        this.onAtualizarAcao.emit(acaoAtividade);
    }

    novo() {
        this.onAdicionar.emit(true);
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    get descricaoFilter(): string {
        return this.descricaoFiltered;
    }

    set descricaoFilter(value: string) {
        this.descricaoFiltered = value;
        this.filteredRequests = this.performFilter();
    }

    get dataFilter(): string {
        return this.dataFiltered;
    }

    set dataFilter(value: string) {
        this.dataFiltered = value;
        this.filteredRequests = this.performFilter();
    }

    performFilter(): MatTableDataSource<Acoes> {
        let filteredRequestsX = this.dataSource.data.filter((request: Acoes) => {
            const descricaoOk = !this.descricaoFiltered || request.descricao?.includes(this.descricaoFiltered);

            const dtInicio = request.dataInicio ? this.dataUtilService.getDataComHorarioZerado(new Date(request.dataInicio)) : null;
            const dtFim = request.dataFim ? this.dataUtilService.getDataComHorarioZerado(new Date(request.dataFim)): null;
            const dtTela: Date = this.dataUtilService.getDataComHorarioZerado(new Date(this.dataFiltered));

            const dataOk = (!dtTela) || (
                (!dtInicio) || (dtTela && dtTela >= dtInicio && dtTela <= (dtFim ?? dtTela))
            );

            return (descricaoOk && (dataOk || !this.dataFiltered));
        });

        return !!this.descricaoFiltered || !!this.dataFiltered
            ? new MatTableDataSource(filteredRequestsX)
            : this.dataSource;
    }

}
